import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
  labels: [],
  datasets: [
    {
      label: "",
      data: [82, 18],
      backgroundColor: ["rgba(0, 145, 255)", "rgba(242, 243, 245, 1)"],
    },
  ],
};

export const data2 = {
  labels: [],
  datasets: [
    {
      label: "",
      data: [64, 36],
      backgroundColor: ["rgba(0, 145, 255)", "rgba(242, 243, 245, 1)"],
    },
  ],
};

const options = {
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  rotation: -135,
  circumference: 270,
  cutout: "60%",
  maintainAspectRatio: true,
  responsive: true,
};

export default function DoughnutChart() {
  return (
    <div style={{ height: "320px", position: "relative", display: "block" }}>
      <div
        style={{
          maxWidth: "48%",
          display: "inline-block",
          position: "relative",
        }}
      >
        <Doughnut data={data} options={options} />
        <div
          style={{
            position: "absolute",
            top: "55%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          <div style={{ "font-size": "25px" }}>
            <strong>{data.datasets[0].data[0]}%</strong>
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: "0",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          <div>Usage 1</div>
        </div>
      </div>
      <div
        style={{
          maxWidth: "48%",
          display: "inline-block",
          position: "relative",
        }}
      >
        <Doughnut data={data2} options={options} />
        <div
          style={{
            position: "absolute",
            top: "55%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          <div style={{ "font-size": "25px" }}>
            <strong>{data2.datasets[0].data[0]}%</strong>
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: "0",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          <div>Usage 2</div>
        </div>
      </div>
    </div>
  );
}
